//  Copyright (c) 2018 First Foundry Inc. All rights reserved.

export const PATH = 'navigation'
export const SIDE_NAVIGATION_TRIGGERED = `${PATH}/SIDE_NAVIGATION_TRIGGERED`
